<ui-kit-empty-state fxFlexAlign="center center"
                    class="mt-24"
                    [icon]="'ic_transaction'"
                    [title]="'i18n_af_emptyStateTitleTransactionsNotAdded'"
                    [subtitle]="'i18n_af_emptyStateSubtitleTransactionsNotAdded'"
                    buttonLabel="i18n_af_buttonCreateTransaction"/>
